import React from 'react';
import './PdfViewer.css';
import homeIcon from '../asset/homeIcon.png';
import { Link, useLocation } from 'react-router-dom';

const PdfHeader = ({ title, onLanguageChange, language }) => {
  //const location = useLocation();
  //const query = new URLSearchParams(location.search);

  return (
    <header className="pdf-header">
      <div className="header-left">
        <Link to={`/?lang=${language}`}>
          <img src={homeIcon} alt="Home" className="home-icon" />
        </Link>
        <span className='episode-title'>{title}</span>
      </div>
      <div className="pdf-lang-toggle">
        <button 
          onClick={() => onLanguageChange('en')} 
          className={language === 'en' ? 'active' : ''}
        >
          EN
        </button>
        <button 
          onClick={() => onLanguageChange('ko')} 
          className={language === 'ko' ? 'active' : ''}
        >
          KR
        </button>
      </div>
    </header>
  );
}

export default PdfHeader;